<template>
  <span>
    %C₂H₂ = {{ formatNumberValue(data.percentageC2H2) }} |
    %C₂H₄ = {{ formatNumberValue(data.percentageC2H4) }} |
    %CH₄ = {{ formatNumberValue(data.percentageCH4) }}
  </span>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatNumberValue(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
  },
};
</script>
